<template>
  <div class="row d-flex justify-content-center p-0 m-0">
    <b-card class="cardDash p-0 justify-content-end"> 
        <div class="d-flex justify-content-around mb-3">  
          <b-button @click="roomId = 'etec'" variant="outline-primary">Etec</b-button> 
          <b-button @click="roomId = 'fatec'" variant="outline-success">Fatec</b-button>
          <b-button @click="roomId = 'pm-sp'" variant="outline-danger">PM-SP</b-button> 
          <b-button @click="roomId = 'prf'" variant="outline-info">PRF</b-button> 
          <b-button @click="roomId = 'enem'" variant="outline-info">Enem</b-button> 
          <b-button @click="roomId = 'Neuro-Quest'" variant="outline-info">Teste de QI</b-button> 
        
          <h6 class="btn-close flo" @click="toDash">  </h6>  
        </div> 

      <iframe class="iframe-chat" :src="'https://vou-passar-chat.web.app/?username='+username+'&roomId='+roomId"></iframe>
    </b-card> 
  </div>
</template>

<script>
 
export default {
  name: 'ChatCard',
  data() {
    return {
      connected: false,
      messages: [], 
      newMessage: '',
      socket: null,
      username: 'Vou Passar', 
      roomId: 'etec',
    };
  },
  
  methods: { 
    toDash() { 
      this.$emit('toDash'); 
    }, 
  }
};
</script>

<style scoped>

.iframe-chat {
  height: 95%;
  width: 100%;
}
.cardDash {
  height: 90vh;
}
  
</style>